

import { defineComponent } from "vue";

import BasePage from '~/core/base-page';
import MyAccount from './my-account.vue';


export default defineComponent({

    extends: BasePage,

    components: {
        MyAccount,
    },

    data() {
        return {
            menu: [
                {
                    id: 'my-account',
                    title: this.$t('preferences.my_account.title'),
                    subtitle: this.$t('preferences.my_account.subtitle'),
                    icon: 'mdi-account',
                    iconBackgroundColor: '#1ACF42',
                    open: false,
                    component: 'MyAccount'
                }
            ],
        };
    },

    mounted() {
        const entryId = this.$route.hash;
        this.toggle(entryId.replace('#', ''));
    },

    computed: {
        expanded(): boolean {
            return this.menu.every((entry => entry.open))
        },

        current() {
            return this.menu.find(entry => entry.open);
        }
    },

    methods: {
        toggle(entryId: string): void {
            const entry = this.menu.find(entry => entryId === entry.id);
            if(!entry) {
                return;
            }
            this.menu = this.menu.map(entry => ({...entry, open: entryId === entry.id}));
            this.$router.replace({ hash: `#${entryId}`});
        }
    }
})

